import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    public data: any = {
        password: ''
    };

    public loading: boolean = false;
    public returnTo: string = '/dashboard';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(null);
        this.returnTo = new URLSearchParams(location.search).get('returnTo') || '/dashboard';
        const { code, data }: any = await wiz.call('status');
        if (code === 200 && data.allowed) location.href = this.returnTo;
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: '',
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        if (!this.data.password) {
            await this.alert('비밀번호를 입력해주세요.');
            return;
        }

        this.loading = true;
        await this.service.render();
        const { code, data }: any = await wiz.call('login', { password: this.data.password });
        this.loading = false;

        if (code === 200) {
            location.href = this.returnTo;
            return;
        }

        await this.alert(data?.message || '접속에 실패했습니다.');
        await this.service.render();
    }
}

export default PageAccessComponent;